import { DialogActions, DialogContent } from '@material-ui/core';
import React, { useState } from 'react';
import { Alert } from '../common/Alert';
import { Button } from '../common/Button';
import { DialogTitle } from '../common/Dialog';
import { Typography } from '../common/Typography';

export interface DeleteModalProps {
  onClose: () => void;
  deleteAction: () => Promise<boolean>;
  onSuccess: () => void;
  objectName: string;
  description?: string;
}

export const DeleteModal: React.FunctionComponent<DeleteModalProps> = ({
  onClose,
  deleteAction,
  onSuccess,
  objectName,
  description,
}) => {
  const [{ loading, error }, setState] = useState<{ loading: boolean; error?: boolean }>({
    loading: false,
  });

  const handleOnConfirm = async () => {
    setState({ loading: true });

    try {
      if (await deleteAction()) {
        onClose();
        onSuccess();
      } else {
        setState({
          loading: false,
          error: true,
        });
      }
    } catch (error) {
      console.error(error);
      setState({
        loading: false,
        error: true,
      });
    }
  };

  return (
    <>
      <DialogTitle>Delete {objectName}?</DialogTitle>
      <DialogContent>
        {description?.length ? <Typography gutterBottom>{description}</Typography> : null}
        {error && (
          <Alert
            severity='error'
            shown={true}
            text={`'${objectName}' could not be deleted. Please try again later.`}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          <Typography variant='h5'>Cancel</Typography>
        </Button>
        <Button variant='outlined' onClick={handleOnConfirm} disabled={loading}>
          <Typography variant='h5'>Delete</Typography>
        </Button>
      </DialogActions>
    </>
  );
};
